import { createTheme } from '@one-thd/sui-atomic-components';

const PrimarySpringGreen = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

PrimarySpringGreen.palette['--sui-palette-background-primary'] = '100 153 75';

export { PrimarySpringGreen };